import {
  isComponentFormBehaviorDownload,
  isComponentFormBehaviorRedirect,
} from '~/services/origins/contentful';
import { BehaviorType } from '~/shared/domain/models';
import type { ContentfulBehaviors } from '~/services/origins/contentful';
import type { BehaviorSchema } from '~/shared/domain/models';

export const adaptBehavior = (behavior: ContentfulBehaviors): BehaviorSchema | undefined => {
  if (!behavior?.fields) {
    return;
  }

  if (isComponentFormBehaviorDownload(behavior)) {
    if (!behavior.fields.file?.fields.file?.url) {
      throw new Error('Missing file url');
    }

    return {
      type: BehaviorType.download,
      url: behavior.fields.file.fields.file.url,
    };
  }

  if (isComponentFormBehaviorRedirect(behavior)) {
    return {
      type: BehaviorType.redirect,
      url: behavior.fields.url,
    };
  }
};
